import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table'
import { Copy } from '../Icon'

function CoinStats({ funds = [], holders = [] }) {
  if (!funds.length && !holders.length) {
    return null
  }

  return (
    <div className="space-y-6">
      {funds.length > 0 && (
        <Card>
          <CardHeader>
            <CardTitle>Funds Invested</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="rounded-lg border border-walme-border overflow-hidden">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Fund</TableHead>
                    <TableHead className="text-right">Website</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {funds.map(fund => (
                    <TableRow key={fund.name}>
                      <TableCell className="font-medium">{fund.name}</TableCell>
                      <TableCell className="text-right">
                        <a
                          href={fund.url}
                          target="_blank"
                          rel="noreferrer"
                          className="text-walme-primary hover:text-walme-primary-hover transition-colors"
                        >
                          {fund.url}
                        </a>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>
      )}

      {holders.length > 0 && (
        <Card>
          <CardHeader>
            <CardTitle>Major Holders</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="rounded-lg border border-walme-border overflow-hidden">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Address</TableHead>
                    <TableHead className="text-right">Percent</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {holders.map(({ address, percent }, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <div className="flex items-center gap-2">
                          <Copy className="w-4 h-4 text-walme-text-dim cursor-pointer hover:text-walme-primary transition-colors" />
                          <span className="font-mono text-sm">{address}</span>
                        </div>
                      </TableCell>
                      <TableCell className="text-right font-medium">{percent}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  )
}

export default CoinStats
